import React from 'react';
import PropTypes from 'prop-types';
import DateFormatter from '../../../../shared/utils/DateFormatter';
import { DocumentLabel } from '../../../shared/components/DocumentLabel';
import { WorkerLabel } from '../../../shared/components/WorkerLabel';
import { CompanyLabel } from '../../../shared/components/CompanyLabel';
import imgDefaultUser from '../../../../../assets/img/default-user.png';
import { WorkLabel } from '../../../shared/components/WorkLabel';
import { MachineLabel } from '../../../shared/components/MachineLabel';

export default class MessageItem extends React.Component {

    renderMediaLeft(user) {
        if ( !this.props.currentUser ) {
            return null;
        }
        return this.renderAvatar(user);
    }

    renderMediaRight(user) {
        if ( this.props.currentUser ) {
            return null;
        }
        return this.renderAvatar(user);
    }

    renderAvatar(user) {
        let imgUser = imgDefaultUser;
        if ( user.avatar() ) {
            imgUser = user.avatar();
        }
        return (
            <div className="media-left">
                <img src={imgUser} width="48" height="48" alt="User" className="media-object user-image"/>
            </div>
        );
    }

    renderClose() {
        const {
            canArchive,
            archive,
            message,
        } = this.props;

        if ( canArchive && message.active() ) {
            return <i
                className="material-icons pull-right cerrar"
                onClick={() => archive(message.id())}
            >cancel</i>;
        }
        return null;
    }

    render() {
        const { message } = this.props;
        let className = 'media';
        if ( !message.active() ) {
            className += ' closed-message';
        }

        return (
            <div className={className}>
                {this.renderMediaLeft(message.user())}
                <div className="media-body">
                    {this.renderClose()}
                    <small className="pull-right time"><i
                        className="material-icons">access_time</i> {DateFormatter.formatDatetime(message.date())}
                    </small>

                    <h5 className="media-heading m-b-0">
                        {message.user() && message.user().completeName()}
                    </h5>
                    <div className="ps-message-labels">
                        <CompanyLabel company={message.company()}/>
                        <WorkerLabel worker={message.worker()}/>
                        <WorkLabel work={message.work()}/>
                        <MachineLabel machine={message.machine()}/>
                    </div>
                    <DocumentLabel document={message.document()}/>
                    <p>{message.body()}</p>
                </div>
                {this.renderMediaRight(message.user())}
            </div>
        );
    }

}

MessageItem.propTypes = {
    message: PropTypes.objectOf(PropTypes.any).isRequired,
    canArchive: PropTypes.bool.isRequired,
    currentUser: PropTypes.bool.isRequired,
    archive: PropTypes.func,
    user: PropTypes.any.isRequired,
};

MessageItem.defaultProps = {
    canArchive: true,
    currentUser: false,
    archive: () => {},
    user: {},
};



// WEBPACK FOOTER //
// ./src/app/messages-notifications/messages/to-refactor/detail/MessageItem.js